import { Upload } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import { formatMoneyCents } from "@/core/utils/money";
import { useStAdjustmentsSection } from "./st-adjustments-section";

/**
 * The PushPay control for the page header's section slot.
 *
 * Renders nothing until the run has a pushable line, so an untagged period
 * leaves the header alone.
 */
export const StAdjustmentsHeaderActions = () => {
  const { hasRows, push, pushExpected, pushCents, selection, stagePush } =
    useStAdjustmentsSection();

  if (!hasRows) return null;

  return (
    <Button
      size="sm"
      leftIcon={<Upload className="h-4 w-4" />}
      loading={push.isBusy}
      disabled={pushExpected === 0 || push.isBusy}
      onClick={stagePush}
    >
      {push.isActive
        ? "Pushing…"
        : pushExpected === 0
          ? "Nothing to push"
          : selection.hasSelection
            ? `Push ${pushExpected} · ${formatMoneyCents(pushCents) ?? "$0"}`
            : `Push all ${pushExpected} · ${formatMoneyCents(pushCents) ?? "$0"}`}
    </Button>
  );
};
